import styled from "styled-components";
import { motion } from "framer-motion";

export const StyledAppAnimateWhileTap = styled(motion.div)`
  height: ${({ full_height }) => (full_height === "true" ? "100%" : "auto")};
  width: ${({ full_width }) => (full_width === "true" ? "100%" : "auto")};
`;
